import {FC} from 'react';

type Icon = {
    className?: string;
};

const GreenCheck: FC<Icon> = ({className}) => (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.54972 9.15L14.0247 0.675C14.2247 0.475 14.4622 0.375 14.7372 0.375C15.0122 0.375 15.2497 0.475 15.4497 0.675C15.6497 0.875 15.7497 1.1125 15.7497 1.3875C15.7497 1.6625 15.6497 1.9 15.4497 2.1L6.24972 11.3C6.04972 11.5 5.81639 11.6 5.54972 11.6C5.28305 11.6 5.04972 11.5 4.84972 11.3L0.549719 7C0.349719 6.8 0.253885 6.5625 0.262219 6.2875C0.270552 6.0125 0.374719 5.775 0.574719 5.575C0.774719 5.375 1.01222 5.275 1.28722 5.275C1.56222 5.275 1.79972 5.375 1.99972 5.575L5.54972 9.15Z"
            fill="#5AE288"
        />
    </svg>
);

export default GreenCheck;
